import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {
  Form,
  SidebarFormHeader,
  TextfieldElement,
  SelectElement, SidebarFormFooter,withAuthentication

} from "cw-styleguide-react";

import withAssets from '../../../../components/hoc/withAssets';
import {TRANSLATOR_UNASSIGNED} from "../../../../constants";

class VenusManageTranslateFilterForm extends Component {

  render() {
    return (
      <Form theme={['sidebar']} classes={['sidebar--can-collapse']}>
        <SidebarFormHeader  heading={this.props.t('styleguide:forms.filterBy')}  searchButtonText={this.props.t('styleguide:forms.applyFilters')} handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset}/>
        <div className="form__body">
          {/* Venue name */}
          <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.translateManage.filters.venueName.label')}
                            id={'venueName'}
                            name={'venueName'}
                            value={this.props.filterValues.venueName}
                            onChange={this.props.handleChange}
                            onKeyPress={this.context.preventDefaultOnEnter}/>

          {/* Postcode */}
          <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.translateManage.filters.postCode.label')}
                            id={'postCode'}
                            name={'postCode'}
                            placeholder={this.props.t('local:view.venues.translateManage.filters.postCode.placeholder')}
                            value={this.props.filterValues.postCode}
                            onChange={this.props.handleChange}
                            onKeyPress={this.context.preventDefaultOnEnter}/>
          {/* Town/City */}
          <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.translateManage.filters.townCity.label')}
                         id={'townCity'}
                         name={'townCity'}
                         placeholder={this.props.t('local:view.venues.translateManage.filters.townCity.placeholder')}
                         value={this.props.filterValues.townCity}
                         onChange={this.props.handleChange}
                            onKeyPress={this.context.preventDefaultOnEnter}
                       />

          {/* Status */}
          <SelectElement size={'medium'} label={this.props.t('local:view.venues.translateManage.filters.status.label')}
                         id={'status'}
                         name={'status'}
                         value={this.props.filterValues.status}
                         onChange={this.props.handleChange}
                         grouped={true}
                         options={[{
                           value: '',
                           label: this.props.t('styleguide:forms.all')
                         },
                           {
                             value: '267040002',
                             label: this.props.courses.getStatusName('267040002')
                           }
                         ,
                           {
                             value: '267040005',
                             label: this.props.courses.getStatusName('267040005')
                           }
                         ]}
          />



          {/* Assigned */}
          <SelectElement size={'medium'} label={this.props.t('local:view.venues.translateManage.filters.translatorAssigned.label')}
                         id={'translatorAssigned'}
                         name={'translatorAssigned'}
                         value={this.props.filterValues.translatorAssigned}
                         onChange={this.props.handleChange}
                         grouped={true}
                         options={

                           this.props.authentication.hasRole('Courses_TranslatorManager') ? [
                               {
                                 value: '',
                                 label: this.props.t('styleguide:forms.all')
                               },
                               {
                                 value: TRANSLATOR_UNASSIGNED,
                                 label: this.props.t('styleguide:forms.unassigned')
                               }
                             ].concat(this.props.translators)
                             :
                             [

                               {
                                 value: TRANSLATOR_UNASSIGNED,
                                 label: this.props.t('styleguide:forms.unassigned')
                               }
                             ].concat(this.props.translators)


                         }
          />
          <SidebarFormFooter handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset}   searchButtonText={this.props.t('styleguide:forms.applyFilters')}/>
        </div>
      </Form>
    );
  }

}

export default withAssets(withAuthentication(withTranslation('local')(VenusManageTranslateFilterForm)));
